import AddMediaComponent from "./AddMediaComponent";

export default AddMediaComponent;
